export const PRE_ORDER_SUGGESTION_TABLE = "preOrderSuggestions"
export const PRE_ORDER_SUGGESTION_TABLE_SCHEMA =
  "id, companyId, targetId, syncId"
